/**
 * Accepts the page type (search or detail) and returns the appropriate lab and
 * imaging text
 *
 * @param type - The type of service ('labs', 'diagnostic imaging', or other)
 * @returns Appropriate text based on the service type
 */
export const labsAndImagingText = (type: string): string => {
  switch (type) {
    case 'labs':
      return 'including imaging'
    case 'diagnostic imaging':
      return 'including labs'
    default:
      return 'including labs and imaging'
  }
}
